import React, { useEffect, useState } from 'react'
import RightBarDataForOtherPages from '../Components/RightBarDataForOtherPages';
import { Grid, makeStyles } from "@material-ui/core";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import { ArrowBack } from '@mui/icons-material';
import Card from "@mui/material/Card";
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import { Info, KeyboardReturnOutlined } from '@mui/icons-material';
import useStyle from '../Css/MainCss';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete'
import { CONFIG } from '../config'
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EvaluateComponent from '../Components/EvaluateComponent';
import SavePageAs from '../Components/SavePageAs';
import Tooltip from '@mui/material/Tooltip';
import { Close } from '@mui/icons-material';
import Draggable from 'react-draggable';
import RiskRegisterComponent from '../Components/RiskRegisterComponent';
import { ClockLoader } from 'react-spinners';
import EvaluateComponent1 from '../Components/EvaluateComponent1';

const useStyles = makeStyles((theme) => ({
  right: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  pageTop: {
    marginTop: '115px',
  },
  pageBodyStyle: {

    paddingTop: '12px',

  },



}));

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const QuestionsForGeneratingRiskRegister = () => {

  const Input = styled('input')({
    display: 'none',
  });

  const [loading, setLoading] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const navigate = useNavigate();
  const [PageName, setPageName] = useState('Questions For Generating RiskRegister')
  const [headerInfoMessage, setheaderInfoMessage] = useState("Create Questions For Generating RiskRegister");

  const [waitingOpen, setWaitingOpen] = React.useState(false);

  React.useEffect(() => {
    getSessionData();
    getColors();
  }, []);

  const [globalCentreId, setGlobalCentreId] = React.useState('');

  const [createUser, setCreateUser] = React.useState('');
  function getSessionData() {
    let data = sessionStorage.getItem('sessionstorage');
    data = JSON.parse(data);
    setCreateUser(data.name)
    setGlobalCentreId(data.centreId);
    console.log(data)

  }

  const [colorPatterns, setColorPatterns] = React.useState([])

  function getColors() {
    axios(CONFIG.MAIN_URL + CONFIG.CONTROLLER_NAME_FOR_SLIDER_COLOR + "/all", {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("+++++++++++++++++All colors++++++++++++++++++");
        console.log(response.data);
        setColorPatterns(response.data);

      })
      .catch(function (error) {
        console.log(error);
      });
  }


  const [questionId, setQuestionId] = useState('');

  const [questionTextArea, setQuestionTextArea] = useState('');

  const [editData, setEditData] = useState(false);

  const [TableData, setTableData] = useState([]);

  const [addButton, setAddButton] = useState('ADD');

  const [showTable, setShowTable] = useState(true);

  const [questiomRes, setQuestiomRes] = useState('');
  const [questionObj, setQuestionObj] = useState({});

  //const options = ['1', '2', '3', '4', '5'];
  const options = [];
  const [showHideStatus, setShowHideStatus] = React.useState(1);
  const [mainSection, setMainSection] = useState('');

  const [entityName, setEntityName] = React.useState('');
  const [subSection, setSubSection] = useState('');

  const [subSectionList, setSubSectionList] = useState([]);

  const handleEntityName = (event) => {
    setEntityName(event.target.value);
  };

  const handleSubSectione = (event) => {
    setSubSection(event.target.value);
  };

  const radioHandler = (status) => {
    setShowHideStatus(status);

  };

  const handlChangeMainSection = (event) => {
    setMainSection(event.target.value);
  };



  const handlequestionId = (event) => {
    setQuestionId(event.target.value);
  };


  const handleQuestionTextArea = (event) => {
    setQuestionTextArea(event.target.value);
  };

  function addToTableFunction() {

    if (mainSection === '') {
      alert('Main Section Can not be empty')
      return
    }
    if (editData === false) {
      var obj = {}
      // obj["messageId"] = questionId
      //obj["message"] = questionTextArea
      obj["mainSection"] = mainSection

      TableData.push(obj)

      setQuestionId('')
      setQuestionTextArea('')
      setEntityName('')
      setSubSection('')
      setMainSection('')
      setSubSectionList([])

      console.log(TableData)
    } else {

      var obj = {}
      // obj["messageId"] = questionId
      // obj["message"] = questionTextArea
      obj["mainSection"] = mainSection
      TableData.push(obj)
      setQuestionId('')
      setQuestionTextArea('')
      setEntityName('')
      setSubSection('')
      setMainSection('')
      setSubSectionList([])
      setEditData(false)
      setAddButton('ADD')


    }

  }


  function editQuestionArrary(mainSection) {
    setEditData(true)
    setAddButton('EDIT')
    {
      TableData.map((row, index) => {
        if (row.mainSection === mainSection) {
          setMainSection(row.mainSection)
        }
      })
    }

    const updatedItems = TableData.filter((item) => item.mainSection !== mainSection);
    console.log(updatedItems)

    setTableData(updatedItems)




  }

  function deleteQuestionArrary(mainSection) {

    const updatedItems = TableData.filter((item) => item.mainSection !== mainSection);
    setTableData(updatedItems)
    console.log(TableData)

  }


  const [registerTypeDataForEval, setRegisterTypeDataForEval] = React.useState({});
  const [editRiskHirachy, setEditRiskHirachy] = React.useState(false);
  const [selectedRegisterEvaluateTitle, setSelectedRegisterEvaluateTitle] = React.useState('');


  function createJsonObject(obj) {
    console.log("+++++++++++++++++++obj+++++++++++++++++++++");
    console.log(obj);
    var regTmpId = 100000;
    obj.riskRegister.forEach((data) => {
        data["riskTypeId"] = regTmpId
        regTmpId++;
        data.risks.forEach((risk) => {
            risk["riskTypeId"] = regTmpId
            regTmpId++;
            if (risk.riskHierarchy != undefined && risk.riskHierarchy != null) {
                if (risk.riskHierarchy.riskHierarchyData != undefined && risk.riskHierarchy.riskHierarchyData != null) {
                    var riskHierarchyObj = risk.riskHierarchy.riskHierarchyData;
                    if (riskHierarchyObj.riskTypes != undefined && riskHierarchyObj.riskTypes != null && riskHierarchyObj.riskTypes.length > 0) {
                        risk["subRisks"] = riskHierarchyObj.riskTypes;
                    }
                }

            }

        })
    })

    var dataStr = JSON.stringify(obj);
    dataStr = dataStr.replaceAll("\"riskRegister\"", "\"riskTypes\"");
    dataStr = dataStr.replaceAll("\"section\"", "\"name\"");
    dataStr = dataStr.replaceAll("\"risks\"", "\"subRisks\"");
    dataStr = dataStr.replaceAll("\"likelihood\"", "\"riskLikelihood\"");
    dataStr = dataStr.replaceAll("\"impact\"", "\"riskImpact\"");
    var jsonObj = JSON.parse(dataStr)

    return jsonObj;


  }

  var globalIdCount = 1;

  function assignExtraAttributes(data, tmpIdCount) {
    data.forEach((item) => {
        item["riskTypeTmpId"] = globalIdCount
        console.log(globalIdCount)
        globalIdCount++;
        if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
            assignExtraAttributes(item.subRisks, tmpIdCount);
        }
    })
    return tmpIdCount;
}


const [multipleRoles, setMultipleRoles] = React.useState(false);


function evaluateRiskFuction() {
  setRegisterTypeDataForEval({});

  setEditRiskHirachy(false)
  
  setOpenDisplayChoice(true)
  
  //getAllRegisterEval(globalCentreId, selectedRegisteredId);
  //setRegisterEvaluate(true)
  //setOpenRegisterDataForEval(true)
  //setOpenRegisterDataForEvalScroll('paper');

}


function byRoleFuction(){
  getAllRegisterEval(globalCentreId, selectedRegisteredId, 'Role');
  setRegisterEvaluate(true)
  setOpenRegisterDataForEval(true)
  setOpenRegisterDataForEvalScroll('paper');
  setOpenDisplayChoice(false);
}
function byRiskNameFuction(){
  getAllRegisterEval(globalCentreId, selectedRegisteredId, 'RiskName');
  setRegisterEvaluate(true)
  setOpenRegisterDataForEval(true)
  setOpenRegisterDataForEvalScroll('paper');
  setOpenDisplayChoice(false);
}



function getAllRegisterEval(centrId, regId, type) {
    axios(CONFIG.MAIN_URL + `/register/all`, {
      method: 'get',
    })
      .then(function (response) {
        //var arr = []
        console.log("all register");
        console.log(response.data);
        response.data.forEach((item) => {
          if (item.centreId === centrId && item.id === regId) {
            var tmpIdCount = 1;
            var tmpIdCount1 = 1;
            var jsonObj = createJsonObject(item);
            setSelectedRegisterEvaluateTitle(item.name)
            
            
            globalIdCount = 1;
            jsonObj.riskTypes.forEach((item, index) => {
                item["riskTypeTmpId"] = globalIdCount;
                console.log(globalIdCount)
                globalIdCount++
                if (item.subRisks != undefined && item.subRisks != null && item.subRisks.length > 0) {
                    tmpIdCount = assignExtraAttributes(item.subRisks, tmpIdCount);
                    tmpIdCount++;
                }

            })


            setRegisterTypeDataForEval(jsonObj);

            setMultipleRoles(false)

            var mainArr = []
            jsonObj.riskTypes.forEach((data) => {
                var secName = data.role;
                var obj = {};
                var arr = [];
                var canTake = true;

                mainArr.forEach((arrData) => {
                    if (arrData.role === secName) {
                        canTake = false;
                    }
                })

                if (canTake) {
                    jsonObj.riskTypes.forEach((item) => {
                        if (secName === item.role) {
                            arr.push(item);
                        }
                    })

                    obj["role"] = data.role

                    mainArr.push(obj);
                }
            })

            if (mainArr.length > 1) {
                setMultipleRoles(true)
            }

            if (type === "RiskName"){
              setMultipleRoles(false)
            }




          }

        })

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [openRegisterDataForEval, setOpenRegisterDataForEval] = React.useState(false);
  const [openRegisterDataForEvalScroll, setOpenRegisterDataForEvalScroll] = React.useState('paper');
  const [registerEvaluate, setRegisterEvaluate] = React.useState(false);

  const [fullScreenState, setFullScreenState] = React.useState(false);
  const [fullScreenStateRegister, setFullScreenStateRegister] = React.useState(false);
  const [fullScreenStateMsg, setFullScreenStateMsg] = React.useState('Full Screen');
  const [maxWidthState, setMaxWidthState] = React.useState('lg');

  function PaperComponentCollectionDataRegister(props) {
    return (
      <Draggable
        handle="#register-data-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const [openDisplayChoice, setOpenDisplayChoice] = React.useState(false);
  const handleCloseDisplayChoice = () => {
    setOpenDisplayChoice(false);
  };



  function RegisterDataForEvalfunctionClose() {
    setOpenRegisterDataForEval(false)
  }



  const [openRegisterEdit, setOpenRegisterEdit] = React.useState(false);
  const [openRegisterEditScroll, setOpenRegisterEditScroll] = React.useState('paper');


  function editRiskFuction() {
    setOpenRegisterEdit(true)
    setOpenRegisterEditScroll('paper');
  }


  function clearButton() {
    setQuestiomRes('');
    setQuestionObj({});
    setQuestionId('');
    setShowTable(true)
    setShowEvaluateAndEditBtn(false);
    setRiskName('')
    setRegisterDescription('');
  }


  const [openConfirm, setOpenConfirm] = React.useState(false);

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };



  const [riskName, setRiskName] = React.useState('');

  const handleChangeRiskName = (event) => {
    setRiskName(event.target.value);
  };

  const [registerDescription, setRegisterDescription] = React.useState('')

  const registerDescriptionOnChange = (event) => {
    setRegisterDescription(event.target.value)
  }

  const [registerJsonStr, setRegisterJsonStr] = React.useState('')

  function createRegister() {
    var dataStr = "";
    questionObj.messages.map((item, index) => {
      if (index === questionObj.messages.length - 1) {
        item.answers.map((data, index) => {
          if (data.messageId === questionId) {
            dataStr = data.answer;
            dataStr = dataStr.replaceAll("\n", "");
          }
        })
      }
    })
    if (dataStr != "") {
      setRegisterJsonStr(dataStr);
      setOpenConfirm(true);
    } else {
      alert("No register updated in the database");
    }

  }

  const [selectedRegisteredArray, setSelectedRegisteredArray] = React.useState([]);
  const [selectedRegisteredId, setSelectedRegisteredId] = React.useState('');
  const [selectedRegisteredName, setSelectedRegisteredName] = React.useState('');
  const [showEvaluateAndEditBtn, setShowEvaluateAndEditBtn] = React.useState(false);


  function handleUpdate() {
    if (riskName === '') {
      alert("Please assign a Register Name");
      return;
    }
    if (registerDescription === '') {
      alert("Please type a Register Description");
      return
    }

    try {
      var jObj = JSON.parse(registerJsonStr);
      console.log(jObj);
      var riskRegisterValidate = true
      if (riskRegisterValidate) {
        setWaitingOpen(true);
        //setLoading(true);
        var riskObj = {};
        riskObj["documentCreator"] = "expert";
        riskObj["name"] = riskName;
        riskObj["description"] = registerDescription;
        riskObj["centreId"] = globalCentreId;
        riskObj["status"] = "Draft";
        if (jObj.riskRegister != undefined && jObj.riskRegister != null && jObj.riskRegister.length > 0) {
          var mainArr = [];
          jObj.riskRegister.forEach((data) => {
            var tmpObj1 = {};
            tmpObj1["section"] = data.section;
            tmpObj1["role"] = data.role;
            tmpObj1["likelihood"] = data.likelihood;
            tmpObj1["impact"] = data.impact;
            tmpObj1["riskLevel"] = data.riskLevel;
            tmpObj1["riskAppetite"] = data.riskAppetite;
            var subArr = [];
            if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
              data.risks.forEach((data1) => {
                var tmpObj2 = {};
                tmpObj2["name"] = data1.riskHierarchy.description;
                tmpObj2["description"] = data1.description;
                tmpObj2["likelihood"] = data1.likelihood;
                tmpObj2["impact"] = data1.impact;
                tmpObj2["riskLevel"] = data1.riskLevel;
                tmpObj2["riskAppetite"] = data1.riskAppetite;
                var tmpObj3 = {};
                var riskId = ""; //getRiskId(data1.riskHierarchy.key);
                tmpObj3["riskId"] = riskId;

                tmpObj3["key"] = data1.riskHierarchy.key;
                tmpObj3["name"] = data1.riskHierarchy.description;
                tmpObj2["riskHierarchy"] = tmpObj3;
                subArr.push(tmpObj2);
              })
              tmpObj1["risks"] = subArr;
            }
            mainArr.push(tmpObj1);
          })
          riskObj["riskRegister"] = mainArr;
        }
        console.log(riskObj);

        var sendingData = "mutation{createRegisterData(registerName:\"" + riskName + "\",status:\"" + 'draft' + "\",centreId:\"" + globalCentreId + "\"){registerId,registerName,status,centreId }}"

        axios(CONFIG.MAIN_URL + '/graphql', {
          method: 'post',
          headers: {
            'Content-Type': 'text/plain'
          },
          data: sendingData
        })
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            let rtnData = response.data;
            console.log("++++++++++ register Data save in PG");
            console.log(rtnData);
            console.log("++++++++++ register Data save in PG");
            riskObj["registerUniqueName"] = globalCentreId + "_register_" + rtnData.data.createRegisterData.registerId;
            console.log(riskObj);
            console.log(JSON.stringify(riskObj));
            let sendJson = JSON.stringify(riskObj);
            axios(CONFIG.MAIN_URL + '/register/save', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
              },
              data: sendJson,
            })
              .then(function (response) {
                setWaitingOpen(false);
                //setLoading(false);
                console.log(JSON.stringify(response.data));
                console.log(response.data);
                let rtnData = response.data;
                alert("Register saved successfully.");

                var registerId = response.data.id;
                var name = response.data.name;

                setSelectedRegisteredArray(response.data);
                setSelectedRegisteredId(registerId);
                setSelectedRegisteredName(name);

                setOpenConfirm(false);
                setShowEvaluateAndEditBtn(true);
              })
              .catch(function (error) {
                setWaitingOpen(false);
                //setLoading(false);
                console.log(error);
                alert("Error saving Register-:" + error);
              });
          })
          .catch(function (error) {
            setWaitingOpen(false);
            //setLoading(false);
            console.log(error);
            alert("Error saving register Data to Database Server -:" + error);
          });




      }

    } catch (error) {
      alert("Invalid Json in the Text Area. Please correct it and Press validate button again")
      setOpenConfirm(false);
    }










  }


  const QuestionTableRowData = (
    <TableBody>
      {TableData.map((row, index) => {
        return (
          <StyledTableRow key={index} className={classes.tableTrStyle}>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle}>
              <div style={{ whiteSpace: 'normal' }}>{row.mainSection}</div>
            </StyledTableCell>
            <StyledTableCell align="right" className={classes.tableTrStyle}>
              <EditIcon
                className={classes.mousePointer}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  editQuestionArrary(row.mainSection);
                }}
              />
            </StyledTableCell>
            <StyledTableCell align="right" className={classes.tableTrStyle}>
              <DeleteIcon
                className={classes.mousePointer}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  deleteQuestionArrary(row.mainSection);
                }}
              />
            </StyledTableCell>
          </StyledTableRow>
        );
      })}
    </TableBody>
  );



  function sendToDataBase() {

    if (riskName === '') {
      alert("Please Register Name")
      return;
    }
    if (registerDescription === '') {
      alert("Please enter Register Description")
      return;
    }
    if (questionId === '') {
      alert("Please enter question id")
      return;
    }
    if (TableData.length === 0) {
      alert("Please enter Key words and to the table")
      return;
    }

    //setWaitingOpen(true);
    setLoading(true);
    var obj = {}
    obj["userId"] = globalCentreId
    obj["createdBy"] = createUser


    var questionStr = "";

    questionStr += "Using the following JSON schema, create a risk register to cover ";
    //questionStr += "Using the following JSON schema, create a risk register to cover Risk hierachies Equipment failure and Labor shortage within the main sections production";


    var objArr = [];

    TableData.forEach((item, index) => {
      if (index === 0) {
        questionStr += item.mainSection;
      } else {
        if (index === TableData.length - 1) {
          questionStr += " and " + item.mainSection;
        } else {
          questionStr += ", " + item.mainSection;
        }
      }
    })





    questionStr += " and show it as a JSON object only : ";

    questionStr += "{   '$schema': 'http://json-schema.org/draft-07/schema#',   'type': 'object',   'properties': {     'riskRegister': {       'type': 'array',       'items': {         'type': 'object',         'properties': {           'section': {             'type': 'string'           },           'role': {             'type': 'string'           },           'likelihood': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'impact': {             'type': 'integer',             'minimum': 1,             'maximum': 5           },           'riskLevel': {             'type': 'integer',             'minimum': 1,             'maximum': 25           },           'riskAppetite': {             'type': 'integer',             'minimum': 1,             'maximum': 10           },           'risks': {             'type': 'array',             'items': {               'type': 'object',               'properties': {                 'description': {                   'type': 'string'                 },                 'likelihood': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'impact': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 5                 },                 'riskLevel': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 25                 },                 'riskAppetite': {                   'type': 'integer',                   'minimum': 1,                   'maximum': 10                 },                 'riskHierarchy': {                   'type': 'object',                   'properties': {                     'key': {                       'type': 'string'                     },                     'description': {                       'type': 'string'                     }                   },                   'required': [                     'key',                     'description'                   ]                 }               },               'required': [                 'description',                 'likelihood',                 'impact',                 'riskLevel',                 'riskAppetite',                 'riskHierarchy'               ]             }           }         },         'required': [           'section',           'role',           'likelihood',           'impact',           'riskLevel',           'riskAppetite',           'risks'         ]       }     }   } }";


    var obj1 = {}
    obj1["messageId"] = questionId;
    obj1["message"] = questionStr;

    objArr.push(obj1);


    obj["chats"] = objArr

    var sendJson = JSON.stringify(obj)

    axios(CONFIG.MAIN_URL + '/openai/chat', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson,
    })
      .then(function (response) {
        //setWaitingOpen(false);
        console.log(JSON.stringify(response.data));
        var schemaStr = JSON.stringify(response.data)
        //schemaStr = schemaStr.replace(/'/g, '"');
        var schemaObj = JSON.parse(schemaStr);
        setQuestionObj(schemaObj);

        setQuestiomRes(JSON.stringify(schemaObj, null, "\t"));
        console.log(response.data)

        var dataStr = "";
        schemaObj.messages.map((item, index) => {
          if (index === schemaObj.messages.length - 1) {
            item.answers.map((data, index) => {
              if (data.messageId === questionId) {
                dataStr = data.answer;
                dataStr = dataStr.replaceAll("\n", "");
              }
            })
          }
        })

        try {
          var jObj = JSON.parse(dataStr);
          console.log(jObj);
          var riskRegisterValidate = true
          if (riskRegisterValidate) {
            //setWaitingOpen(true);
            var riskObj = {};
            riskObj["documentCreator"] = "expert";
            riskObj["name"] = riskName;
            riskObj["description"] = registerDescription;
            riskObj["centreId"] = globalCentreId;
            riskObj["status"] = "Draft";
            if (jObj.riskRegister != undefined && jObj.riskRegister != null && jObj.riskRegister.length > 0) {
              var mainArr = [];
              jObj.riskRegister.forEach((data) => {
                var tmpObj1 = {};
                tmpObj1["section"] = data.section;
                tmpObj1["role"] = data.role;
                tmpObj1["likelihood"] = data.likelihood;
                tmpObj1["impact"] = data.impact;
                tmpObj1["riskLevel"] = data.riskLevel;
                tmpObj1["riskAppetite"] = data.riskAppetite;
                var subArr = [];
                if (data.risks != undefined && data.risks != null && data.risks.length > 0) {
                  data.risks.forEach((data1) => {
                    var tmpObj2 = {};
                    tmpObj2["name"] = data1.riskHierarchy.description;
                    tmpObj2["description"] = data1.description;
                    tmpObj2["likelihood"] = data1.likelihood;
                    tmpObj2["impact"] = data1.impact;
                    tmpObj2["riskLevel"] = data1.riskLevel;
                    tmpObj2["riskAppetite"] = data1.riskAppetite;
                    var tmpObj3 = {};
                    var riskId = ""; //getRiskId(data1.riskHierarchy.key);
                    tmpObj3["riskId"] = riskId;
    
                    tmpObj3["key"] = data1.riskHierarchy.key;
                    tmpObj3["name"] = data1.riskHierarchy.description;
                    tmpObj2["riskHierarchy"] = tmpObj3;
                    subArr.push(tmpObj2);
                  })
                  tmpObj1["risks"] = subArr;
                }
                mainArr.push(tmpObj1);
              })
              riskObj["riskRegister"] = mainArr;
            }
            console.log(riskObj);
    
            var sendingData = "mutation{createRegisterData(registerName:\"" + riskName + "\",status:\"" + 'draft' + "\",centreId:\"" + globalCentreId + "\"){registerId,registerName,status,centreId }}"
    
            axios(CONFIG.MAIN_URL + '/graphql', {
              method: 'post',
              headers: {
                'Content-Type': 'text/plain'
              },
              data: sendingData
            })
              .then(function (response) {
                console.log(JSON.stringify(response.data));
                let rtnData = response.data;
                console.log("++++++++++ register Data save in PG");
                console.log(rtnData);
                console.log("++++++++++ register Data save in PG");
                riskObj["registerUniqueName"] = globalCentreId + "_register_" + rtnData.data.createRegisterData.registerId;
                console.log(riskObj);
                console.log(JSON.stringify(riskObj));
                let sendJson = JSON.stringify(riskObj);
                axios(CONFIG.MAIN_URL + '/register/save', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  data: sendJson,
                })
                  .then(function (response) {
                    setWaitingOpen(false);
                    setLoading(false);
                    console.log(JSON.stringify(response.data));
                    console.log(response.data);
                    let rtnData = response.data;
                    alert("Register Created successfully.");
    
                    var registerId = response.data.id;
                    var name = response.data.name;
    
                    setSelectedRegisteredArray(response.data);
                    setSelectedRegisteredId(registerId);
                    setSelectedRegisteredName(name);

                    setShowTable(false)
                    setTableData([])
    
                    setOpenConfirm(false);
                    setShowEvaluateAndEditBtn(true);
                  })
                  .catch(function (error) {
                    setWaitingOpen(false);
                    setLoading(false);
                    console.log(error);
                    alert("Error saving Register-:" + error);
                  });
              })
              .catch(function (error) {
                setWaitingOpen(false);
                setLoading(false);
                console.log(error);
                alert("Error saving register Data to Database Server -:" + error);
              });
    
    
    
    
          }
    
        } catch (error) {
          alert("Invalid Json created. Please do this again")
          setOpenConfirm(false);
        }

    








        //alert(" Updated database successfully and now You can create Register by pressing 'Create the Register' button ");
        
      })
      .catch(function (error) {
        setWaitingOpen(false);
        setLoading(false);
        console.log(error);
        alert("Error saving Question -:" + error);
      });

  }



  function addSubToTable() {
    var obj = {}
    obj["subName"] = subSection

    subSectionList.push(obj)

    setSubSection('')
  }




  function deletesubArrary(subName) {
    const updatedItems = subSectionList.filter((item) => item.subName !== subName);
    setSubSectionList(updatedItems)
  }

  //dialog

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {

    try {
      var jObj = JSON.parse(questiomRes);
      var dataStr = "";
      jObj.messages.map((item, index) => {
          item.questions.map((data, index) => {
              dataStr = data.question;
              dataStr = dataStr.replaceAll("\n", "");
              dataStr = dataStr.replaceAll("\t", " ");
              dataStr = dataStr.replaceAll("\"", "\'");
              data["question"] = dataStr;
          })
          item.answers.map((data, index) => {
            dataStr = data.answer;
            dataStr = dataStr.replaceAll("\n", "");
            dataStr = dataStr.replaceAll("\t", " ");
            dataStr = dataStr.replaceAll("\"", "\'");
            data["answer"] = dataStr;
        })
      })
      setQuestiomRes(JSON.stringify(jObj, null, "\t"));
      setOpen(true);
    } catch (error) {
      alert("Invalid Json created. Please do this again")
      return;
    }
    
    
  };

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <>

      <RightBarDataForOtherPages PageName={PageName} />

      <div className={classes.pageTop}>
        <Grid container spacing={2}>
          <Grid container spacing={2} className={classes.pageBodyStyle}>

            <Grid item xs={12}>
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" to="/login">
                    <span className='breadcrumbsStyle'>Home</span>
                  </Link>
                  <Typography color="text.primary"><span className='breadcrumbsStyle'>Main menu - Questions For Generating RiskRegister</span></Typography>
                </Breadcrumbs>
              </div>
            </Grid>
            <Grid item xs={12}>
              <a style={{ float: 'right', marginTop: '-36px', color: '#0056b3', cursor: 'pointer' }} onClick={() => navigate(-1)}><ArrowBack /> <span className='breadcrumbsStyle'>Go Back</span></a>
            </Grid>



            <Grid item xs={12}>
              <Card style={{ "width": "100% !important", border: "1px solid black" }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: '#69676e', width: '25px', height: '25px' }}>
                      <Info />
                    </Avatar>
                  }
                  className={classe.commonMainTableHead}
                  title={headerInfoMessage}
                />
                <CardContent>
                  <Grid container spacing={2}>
                  {showTable ?
                   <>
                    <Grid item xs={12}>
                      <FormLabel id="radio-buttons-group-label">What do you want to do?</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="radio-buttons-group-label"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="openEnded"
                          control={<Radio />}
                          label="Create a Risk Register"
                          checked={showHideStatus === 1}
                          onClick={(e) => radioHandler(1)}
                        />
                        <FormControlLabel
                          value="closeEnded"
                          control={<Radio />}
                          label="Create a Risk Hierarchy"
                          checked={showHideStatus === 2}
                          onClick={(e) => radioHandler(2)}
                        />
                      </RadioGroup>
                    </Grid>
                    </>
                    :
                    <>
                    <Grid item xs={12}>
                      <FormLabel id="radio-buttons-group-label">What do you want to do?</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="radio-buttons-group-label"
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="closeEnded"
                          control={<Radio />}
                          label="Create a Risk Hierarchy"
                          checked={showHideStatus === 2}
                          onClick={(e) => radioHandler(2)}
                        />
                      </RadioGroup>
                    </Grid>
                    </>
                  }
                    {showHideStatus === 1 && (
                      <>
                        <Grid item xs={12}>
                          <Card style={{ "width": "100% !important", border: "1px solid black" }}>
                            <CardContent>
                              <Grid container spacing={2}>
                              {showTable ?
                                  <>
                                <Grid item xs={6}>
                                  <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                                    <TextField
                                      id="mainSection1"
                                      label="Register Name"
                                      multiline
                                      variant="outlined"
                                      value={riskName}
                                      onChange={handleChangeRiskName}
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={6}>
                                  <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                                    <TextField
                                      id="mainSection2"
                                      label="Register Description"
                                      multiline
                                      variant="outlined"
                                      value={registerDescription}
                                      onChange={registerDescriptionOnChange}                                    />
                                  </Box>
                                </Grid>

                                
                                <Grid item xs={11}>
                                  <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                                    <TextField
                                      id="mainSection"
                                      label="Enter your Register heading sections separated by commas"
                                      multiline
                                      variant="outlined"
                                      value={mainSection}
                                      onChange={handlChangeMainSection}
                                    />
                                  </Box>


                                </Grid>
                                <Grid item xs={1}>
                                  <Button
                                    variant="contained"
                                    style={{ float: 'right', height: '53px' }}
                                    onClick={() => addToTableFunction()}
                                  >{addButton}</Button>
                                </Grid>
                                
                                    <Grid item xs={12}>
                                      <Card style={{ "width": "100% !important", border: "1px solid black" }}>
                                        <CardHeader
                                          avatar={
                                            <Avatar sx={{ bgcolor: '#69676e', width: '25px', height: '25px' }}>
                                              <Info />
                                            </Avatar>
                                          }
                                          className={classe.commonMainTableHead}
                                          title={'Key words For Generating RiskRegister'}
                                        />
                                        <CardContent>

                                          <Grid item xs={12}>
                                            <div className={classes.scrollableDiv}>
                                              <TableContainer
                                                component={Paper}
                                                sx={{ maxHeight: 440 }}
                                              >
                                                <Table sx={{ minWidth: 400 }} aria-label="customized table" style={{ border: '1px solid #ddd' }}>
                                                  <TableHead className={classe.commonSecondaryTableHead}>
                                                    <TableRow>
                                                      <StyledTableCell className={classe.commonTableThStyle} style={{ width: '70%' }}>Key Words</StyledTableCell>
                                                      <StyledTableCell align="right" className={classe.commonTableThStyle} style={{ width: '50%' }}>Edit</StyledTableCell>
                                                      <StyledTableCell align="right" className={classe.commonTableThStyle} style={{ width: '50%' }}>Delete</StyledTableCell>
                                                    </TableRow>
                                                  </TableHead>
                                                  {QuestionTableRowData}
                                                </Table>
                                              </TableContainer>
                                            </div>

                                          </Grid>

                                        </CardContent>
                                      </Card>
                                    </Grid>
                                    <Grid item xs={7}>
                                      &nbsp;
                                    </Grid>
                                    <Grid item xs={3} style={{ textAlign: 'right' }}>
                                      <TextField
                                        id="questionId"
                                        label="Question Id"
                                        multiline
                                        variant="outlined"
                                        // maxRows={2}
                                        value={questionId}
                                        onChange={handlequestionId}
                                      />
                                    </Grid>
                                    <Grid item xs={2}>
                                      <Button

                                        style={{ float: 'right', height: '53px' }}
                                        variant="contained"
                                        onClick={() => sendToDataBase()}>SUBMIT</Button>
                                      <br></br>
                                    </Grid>
                                  </>

                                  :
                                  <>
                                    <Grid item xs={12}>
                                     <span style={{fontSize: '15px'}}><b>{selectedRegisteredName} </b>has been created.</span>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <div style={{ display: 'flex', gap: '5px', textAlign: 'center' }}>
                                        <Button
                                          variant="contained"
                                          onClick={handleClickOpen}
                                        >Show Response</Button>
                                        {!showEvaluateAndEditBtn ?
                                          <Button
                                            variant="contained"
                                            onClick={() => createRegister()}
                                          >Create the Register</Button>
                                          :
                                          ''
                                        }
                                        {showEvaluateAndEditBtn ?
                                          <>
                                            <Button
                                              variant="contained"
                                              onClick={() => evaluateRiskFuction()}
                                            >
                                              Evaluate
                                            </Button>
                                            <Button
                                              variant="contained"
                                              onClick={() => editRiskFuction()}
                                            >
                                              Edit Register
                                            </Button>
                                          </>
                                          :
                                          ''
                                        }

                                        <Button
                                          variant="contained"
                                          onClick={() => clearButton()}
                                        >clear</Button>
                                      </div>
                                    </Grid>
                                  </>
                                }
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      </>
                    )}
                    {showHideStatus === 2 && (
                      <>
                        {'Not yet Completed'}
                      </>
                    )}
                  </Grid>

                </CardContent>
              </Card>
            </Grid>






          </Grid>
        </Grid>
      </div>

      <div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Questions and answers"}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <textarea
                  name="postContent"
                  rows={20}
                  cols={50}
                  value={questiomRes}
                />
                { }
              </Grid>
            </Grid>


          </DialogContent>
          <DialogActions>

            <Button onClick={handleClose} autoFocus>
              cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>


      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}>
        <DialogTitle>
          Update the Database with Risk Register name and Description
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            To update the database, please enter the Risk Register Name and Description here.
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Register Name"
                type="text"
                value={riskName}
                onChange={handleChangeRiskName}
                fullWidth
                variant="standard"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                id="description"
                label="Register Description"
                type="text"
                value={registerDescription}
                onChange={registerDescriptionOnChange}
                fullWidth
                variant="standard"
              />

            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm}>Cancel</Button>
          <Button onClick={handleUpdate}>Update Database</Button>
        </DialogActions>
      </Dialog>


      {/** For Register Eval */}

      <Dialog
        open={openRegisterDataForEval}
        onClose={false}
        scroll={openRegisterDataForEvalScroll}
        aria-labelledby="register-data-dialog-title"
        aria-describedby="register-data-dialog-description"
        fullWidth={true}
        maxWidth={maxWidthState}
        fullScreen={fullScreenState}
        PaperComponent={PaperComponentCollectionDataRegister}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Evaluate "{selectedRegisterEvaluateTitle}" - <SavePageAs /></Typography>
          <Typography variant="h6" style={{ marginRight: '-22px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={RegisterDataForEvalfunctionClose} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>

        <DialogContent dividers={openRegisterDataForEvalScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
              {multipleRoles?
                  <EvaluateComponent1
                      colorPatterns={colorPatterns}
                      registerTypeDataForEval={registerTypeDataForEval}
                      openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                      registerEvaluate={true}
                  />
              :
                <EvaluateComponent
                  colorPatterns={colorPatterns}
                  registerTypeDataForEval={registerTypeDataForEval}
                  openRegisterDataForEvalScroll={openRegisterDataForEvalScroll}
                  registerEvaluate={registerEvaluate}
                />
              }
              </Grid>
            </Grid>


          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={RegisterDataForEvalfunctionClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/** Edit Register */}
      <Dialog
        open={openRegisterEdit}
        onClose={false}
        scroll={openRegisterEditScroll}
        aria-labelledby="collection-data-dialog-title"
        aria-describedby="collection-data-dialog-description"
        fullWidth={true}
        maxWidth={'lg'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="collection-data-dialog-title">
          <Typography variant="h6" style={{ fontSize: '25px !important' }}>Edit Register - "{selectedRegisteredName}" - <SavePageAs />
          </Typography>
          <Typography variant="h6" style={{ marginRight: '-15px', padding: '7px', marginTop: '-50px', float: 'right' }}>
            <Tooltip title="Close"><Close onClick={() => setOpenRegisterEdit(false)} style={{ cursor: 'pointer' }} /></Tooltip>
          </Typography>
        </DialogTitle>
        <DialogContent dividers={openRegisterEditScroll === 'paper'}>
          <DialogContentText id="main-risk-scroll-dialog-description" tabIndex={-1}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <RiskRegisterComponent
                  selectedRegisteredId={selectedRegisteredId}
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRegisterEdit(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog
                    open={openDisplayChoice}
                    onClose={handleCloseDisplayChoice}>
                    <DialogTitle>
                        Select the Display Method

                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            How do you want to display the Register
                        </DialogContentText>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>&nbsp;</Grid>
                            <Grid item xs={5}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    onClick={() => byRoleFuction()}
                                    className='btnFonts'
                                    style={{float: 'right'}}
                                    >
                                    By Role
                                </Button>
                            </Grid>
                            <Grid item xs={7}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    onClick={() => byRiskNameFuction()}
                                    className='btnFonts'
                                    >
                                    By Risk Name
                                </Button>
                            </Grid>

                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDisplayChoice}>Close</Button>
                    </DialogActions>
                </Dialog>



        <Dialog
          open={loading}
          onClose={false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>
            <span style={{textAlign: 'center'}}>Processing <br></br>
            Please Wait ! ....</span>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <ClockLoader
                    size={100}
                    color={'red'}
                    className={classes.loaderStyle}
                    loading={loading}
                />
              </Grid>
            </Grid>


          </DialogContent>
        </Dialog>




      {/** Dialog Waiting */}
      <Dialog
        maxWidth={'md'}
        open={waitingOpen}
        PaperProps={{ style: { backgroundColor: 'transparent', boxShadow: 'none' } }}
      >
        <CircularProgress disableShrink />
      </Dialog>
    </>
  )
}

export default QuestionsForGeneratingRiskRegister
